import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import { Modal } from '../../components';
import { ensureTransaction, ensureListing, ensureUser } from '../../util/data';
import SectionProposal from '../ApplicationPanel/SectionProposal';
import SectionProfileCard from '../ApplicationPanel/SectionProfileCard';

import css from './ApplicationModal.css';

const ApplicationModal = props => {
  const {
    id,
    isOpen,
    onClose,
    onManageDisableScrolling,
    applicationTransaction,
    intl,
    skillOptions,
    toolOptions,
    portfolioWorks,
  } = props;

  if (!applicationTransaction || !applicationTransaction.id) {
    return null;
  }

  const transaction = ensureTransaction(applicationTransaction);
  const listing = ensureListing(transaction.listing);
  const provider = ensureUser(transaction.provider);
  const customer = ensureUser(transaction.customer);

  const { bestFit = '', similarWork = '', questions = '' } = transaction.attributes.protectedData;

  const listingDeleted = listing && listing.attributes && listing.attributes.deleted;

  return (
    <Modal
      id={id}
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
      wide
    >
      <div className={css.content}>
        <div className={css.main}>
          <SectionProposal
            intl={intl}
            listing={listing}
            listingDeleted={listingDeleted}
            bestFit={bestFit}
            similarWork={similarWork}
            questions={questions}
            portfolioWorks={portfolioWorks || []}
            loadingPortfolioWorks={false}
            onManageDisableScrolling={onManageDisableScrolling}
            skillOptions={skillOptions}
            toolOptions={toolOptions}
          />
        </div>
        <div className={css.sidebar}>
          <SectionProfileCard user={customer} />
        </div>
      </div>
    </Modal>
  );
};

ApplicationModal.propTypes = {
  id: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onManageDisableScrolling: PropTypes.func.isRequired,
  applicationTransaction: PropTypes.object,
  intl: PropTypes.object.isRequired,
  skillOptions: PropTypes.array,
  toolOptions: PropTypes.array,
  portfolioWorks: PropTypes.array,
};

export default ApplicationModal;
